<template>
<v-container fluid>
    <v-card class="ma-2" outlined>
        <v-card-title>
            <v-btn icon @click="$router.go(-1)">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            {{ programInfo.name }}
            <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear indeterminate color="yellow darken-2" v-if="loading"></v-progress-linear>
        <!-- Dialog for confirm update endDate -->
        <v-dialog v-model="dialog" max-width="400px">
            <v-card>
                <v-card-title class="text">Done!</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="toShowProgramView">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-row class="ma-2">
            <v-col cols="12" sm="10">
                <v-layout wrap="true">
                    <v-flex xs12 md2 class="d-none d-md-inline">
                        <p class="text-subtitle-1 bg2-text text-right mr-md-3">วันที่ยกเลิกโปรแกรม</p>
                    </v-flex>
                    <v-flex xs12 md2 class="d-md-none">
                        <p class="text-subtitle-1 mr-md-3">วันที่ยกเลิกโปรแกรม</p>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field :rules="requiredRule" required v-model="computedDateFormattedDate" hint="DD/MM/YYYY" persistent-hint v-bind="attrs" v-on="on" readonly></v-text-field>
                            </template>
                            <v-date-picker v-if="endDateMax && endDateMin" :rules="requiredRule" v-model="editedItem.datepicker" no-title required @input="menu1 = false" :min="endDateMin" :max="endDateMax"></v-date-picker>
                            <v-date-picker v-else :rules="requiredRule" v-model="editedItem.datepicker" no-title required @input="menu1 = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                </v-layout>
            </v-col>

        </v-row>

        <v-row class="ma-2">
            <v-col cols="12" sm="10">
                <v-layout wrap="true">
                    <v-flex xs12 md2 class="d-none d-md-inline">
                        <p class="text-subtitle-1 bg2-text text-md-right mr-md-3">สาเหตุ:</p>
                    </v-flex>
                    <v-flex xs12 md2 class="d-md-none">
                        <p class="text-subtitle-1 text-md-right mr-md-3">สาเหตุ:</p>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-combobox v-model="editedItem.programResult" :items="programResultOption" :rules="requiredRule"></v-combobox>
                    </v-flex>
                    <v-flex xs12></v-flex>
                    <v-flex xs12 md4 offset-md-2 v-if="editedItem.programResult=='อื่นๆ'">
                        <v-textarea outlined :rules="requiredRule" v-model="editedItem.programResultOther">
                        </v-textarea>
                    </v-flex>
                </v-layout>
            </v-col>
        </v-row>
        <v-row class="ma-2">
            <v-col cols="12" sm="10">
                <v-layout wrap="true">
                    <v-flex xs12 md6 text-right>
                        <v-btn color="primary" dark class="ml-5 mt-3" @click="toCancelProgram">
                            ยกเลิกโปรแกรม
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-col>
        </v-row>
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import getProgramMemberInfo from "../data/getProgramMemberInfo";
import {
    mapGetters
} from "vuex";
import setProgramInfo from "../data/setProgramInfo";
import formatData from "../utils/formatData";
import moment from "moment";
export default {
    name: 'ProgramViewMemberCancel',
    metaInfo: {
        title: 'Program View Member Cancel'
    },
    data() {
        return {
            title: '',
            programInfo: {},
            //to validate from
            valid: false,
            requiredRule: [
                (value) => !!value || "Required."
            ],
            refRule: [
                (value) => !!value || "Required.",
            ],
            dialog: false,
            menu1: false,
            editedItem: {
                datepicker: '',
                programResult: ''
            },
            endDateMin: '',
            endDateMax: '',
            enableEndProgram: false,
            loading: false,
            programResultOption: [
                'ติดต่อไม่ได้',
                'ปฏิเสธการเข้าร่วมต่อไป',
                'อื่นๆ'
            ]
        };
    },
    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Coach Program";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
        this.id = this.$route.params.id;
        this.uid = this.$route.params.uid;
    },
    computed: {
        ...mapGetters([
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
            "isAccessCoachAdmin",
            "isAccessOrgAdmin"
        ]),
        computedDateFormattedDate() {
            return this.formatDate(this.editedItem.datepicker);
        },
    },
    watch: {

    },
    methods: {
        initialize() {
            (async () => {
                //check limit access
                if (this.isAccessCoachAdmin) {
                    this.programInfo = await getProgramMemberInfo(this.id, this.uid);
                } else {
                    this.$router.push(`/dashboard`);
                }

                if (this.programInfo.cancelDatePicker != undefined) {
                    this.editedItem.datepicker = this.programInfo.cancelDatePicker;
                }
                if( this.programInfo.startDatePicker != '' ){
                    this.endDateMin = moment(this.programInfo.startDatePicker + ' 00:00:00').format('YYYY-MM-DD');   
                    this.endDateMax = moment().format('YYYY-MM-DD');
                }
                this.loading = false;
            })();
        },
        toShowProgramView() {
            this.$router.push(`/program/${this.$route.params.mod}/view/${this.id}`);
        },
        async toCancelProgram() {
            if( this.editedItem.programResult != 'อื่นๆ' ){
                this.editedItem.programResultOther = '';
            }
            await setProgramInfo({
                action: 'cancelProgram',
                cancelDate: new Date(this.editedItem.datepicker + ' 00:00:00'),
                programResult: this.editedItem.programResult,
                programResultOther: this.editedItem.programResultOther
            }, this.id, this.uid);
            this.dialog = true;
            
        },
        _formatData(type, value) {
            if (!value) return null;
            return formatData(type, value);
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
    },
};
</script>
